import { getUserToken, removeUserToken } from '../../helpers/sessionValidation'

// Ruta real de la pantalla de login (ver LoginPageConfig). Se centraliza para que
// las redirecciones por token ausente/expirado no apunten a una ruta inexistente.
const LOGIN_ROUTE = "/auth/login";

const PUBLIC_ROUTES = [
  LOGIN_ROUTE,
  "/verifications-certificates",
  // Trazabilidad pública del certificado de circularidad (URL impresa en el PDF).
  "/trazabilidad",
  "/contact",
  "/auth/password-recovery",
  "/auth/register"
];

function validateToken(response) {
  if (response.status === 401) {
    // Token invalido, se borra el token del localStorage
    removeUserToken()
    // Se redireje la pagina al login
    globalThis.location.href = LOGIN_ROUTE
    return
  }
  return response
}

function getOptions(method, data = null) {
  globalThis.localStorage.setItem('i18nextLng', 'es');

  const lng = globalThis.localStorage.getItem('i18nextLng')
    ? globalThis.localStorage.getItem('i18nextLng').split('-')[0]
    : 'es';

  const options = {
    method,
    ...(data && { body: JSON.stringify(data) }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getUserToken()}`,
      platform: 'ecorep',
      lng: lng || 'es'
    }
  }
  return options
}

function getOptionsForm(method, data = null) {
  const options = {
    method,
    ...(data && { body: data })
  }
  return options
}

const request = async (url, options) => {
  const baseURL = import.meta.env.VITE_BACKEND_URL;
  const finalUrl = baseURL + url;
  const urlCurrent = globalThis.location.pathname;

  const isPublic = PUBLIC_ROUTES.some((route) => urlCurrent.startsWith(route));

  if (!isPublic && !getUserToken()) {
    removeUserToken();
    globalThis.location.href = LOGIN_ROUTE;
    return;
  }

  try {
    const httpResponse = await fetch(finalUrl, options);

    if (!isPublic && validateToken(httpResponse)) {
      const json = await httpResponse.json();
      return {
        be: "ok",
        data: json
      };
    }

    if (isPublic) {
      const json = await httpResponse.json();
      return {
        be: "ok",
        data: json
      };
    }

    return undefined;
  } catch (error) {
    return {
      be: "nok",
      msg: error.message
    };
  }
};

const requestForm = async (url, options) => {
  const baseURL = import.meta.env.VITE_BACKEND_URL;
  const finalUrl = baseURL + url;
  const urlCurrent = globalThis.location.pathname;

  const isPublic = PUBLIC_ROUTES.some((route) => urlCurrent.startsWith(route));

  if (!isPublic && !getUserToken()) {
    removeUserToken();
    globalThis.location.href = LOGIN_ROUTE;
    return;
  }

  try {
    const httpResponse = await fetch(finalUrl, options);

    if (isPublic) {
      const json = await httpResponse.json();
      return {
        be: "ok",
        data: json
      };
    }

    if (validateToken(httpResponse)) {
      const json = await httpResponse.json();
      return {
        be: "ok",
        data: json
      };
    }

    return undefined;
  } catch (error) {
    return {
      be: "nok",
      msg: error.message
    };
  }
};

function getOptionsBlob(method) {
  globalThis.localStorage.setItem('i18nextLng', 'es');

  const lng = globalThis.localStorage.getItem('i18nextLng')
    ? globalThis.localStorage.getItem('i18nextLng').split('-')[0]
    : 'es';

  const options = {
    method,
    headers: {
      'Accept': 'application/pdf',
      'Authorization': `Bearer ${getUserToken()}`,
      'platform': 'ecorep',
      'lng': lng || 'es'
    }
  }
  return options
}

const requestBlob = async (url, options) => {
  const baseURL = import.meta.env.VITE_BACKEND_URL
  url = baseURL + url

  try {
    const httpResponse = await fetch(url, options)

    if (validateToken(httpResponse)) {
      if (httpResponse.ok) {
        const blob = await httpResponse.blob()
        return {
          be: 'ok',
          data: blob,
          status: httpResponse.status,
          headers: httpResponse.headers
        }
      } else {
        throw new Error(`HTTP error! status: ${httpResponse.status}`)
      }
    }
    return undefined
  } catch (error) {
    return {
      be: 'nok',
      msg: error.message
    }
  }
}

export const GETBlob = (url) => {
  const options = getOptionsBlob('GET')
  return requestBlob(url, options)
}

export const GET = (url) => {
  const options = getOptions('GET')
  return request(url, options)
}

export const POST = (url, data) => {
  const options = getOptions('POST', data)
  return request(url, options)
}

export const POSTForm = (url, data) => {
  const options = getOptionsForm('POST', data)
  return requestForm(url, options)
}
